import { Components, Theme } from '@mui/material/styles'

/**
 * ## `text.primary`, not `primary.contrastText` — both instances are LATENT
 *
 * `contrastText` is the colour legible ON the primary colour, i.e. on a
 * primary-FILLED surface. A form-control label is not on one. `primary.main`
 * defaults to BLACK (`./palette.ts`), so MUI computes `contrastText` as `#fff`, and
 * a DISABLED control's label would have been white — at 38% opacity, on white.
 *
 * ## Neither rule fires today, and that was measured, not assumed
 *
 * Dumped the emotion rules this file emits, live in the browser, and matched each
 * selector against the DOM:
 *
 * | selector | matches |
 * |---|---|
 * | `…-MuiFormControlLabel-root.Mui-disabled` | **0** |
 * | `…-MuiFormControlLabel-root.filterTitle.Mui-disabled span` | **0** |
 *
 * No `<FormControlLabel>` in `apps/app` is passed `disabled`, and `.filterTitle` has
 * no consumer anywhere in the source — the class name appears only here. The 20 live
 * FormControlLabels on the certificates surface measured `rgb(0,0,0)` on white, 21:1.
 *
 * Note MUI's own `.MuiFormControlLabel-label.Mui-disabled` (0-3-0) already paints
 * the LABEL `rgba(0,0,0,0.38)` and out-specifies the rule below (0-2-0), so what the
 * root's colour actually reaches is anything inheriting it — an icon drawn in
 * `currentColor`, say. `opacity: 0.38` is what conveys "disabled" here and is kept;
 * the colour underneath it just has to be the readable one.
 *
 * `.filterTitle` is left in place rather than deleted: removing an unreferenced
 * selector is a separate call from fixing the colour in it, and this change is
 * scoped to the colour.
 */
export const MuiFormControlLabel: Components<Theme>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      marginLeft: '-3px',
      '&.filterTitle': {
        '&.Mui-disabled': {
          span: {
            color: theme.palette.text.primary,
          },
        },
      },
      '&.Mui-disabled': {
        color: theme.palette.text.primary,
        opacity: 0.38,
      },
      span: {
        fontWeight: 700,
        '&.MuiTypography-root': {
          marginLeft: '16px',
        },
      },
    }),
  },
}
